import { motion } from 'motion/react';
import styled from 'styled-components';

export const Card = styled(motion.div)`
  position: absolute;
  inset: 0;
  overflow: hidden;
  touch-action: none;
`;
